var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"optionItem",class:{selection:_vm.on},on:{"click":function($event){return _vm.goto()},"mouseenter":function($event){_vm.on=true},"mouseleave":function($event){_vm.on=false}}},[_vm._v(" "+_vm._s(_vm.itemName)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }